<script>
import WaveSurfer from "wavesurfer.js";
import IconsPlay from "@/assets/Icons/play.vue";
import IconsPause from "@/assets/Icons/pause.vue";

export default {
  name: "AudioPlayer",
  props: {
    link: {
      type: String,
      required: true,
    },
  },
  components: {
    IconsPlay,
    IconsPause,
  },
  data() {
    return {
      wavesurfer: null,
      isPlaying: false
    };
  },
  methods: {
    togglePlay() {
      if (!this.wavesurfer) return;
      this.wavesurfer.playPause();
      this.isPlaying = this.wavesurfer.isPlaying();
    },
  },
  mounted() {
    this.wavesurfer = WaveSurfer.create({
      container: this.$refs.waveform,
      waveColor: "#949494",
      progressColor: "#fff",
      cursorColor: "#fff",
      height: 100,
      responsive: true,
      url: `https://corsproxy.io/?${encodeURIComponent(this.link)}`,
    });

    this.wavesurfer.on("finish", () => {
      this.isPlaying = false;
    });

    this.wavesurfer.on("interaction", () => {
      this.wavesurfer.play();
    });
  },
  beforeUnmount() {
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
      this.wavesurfer = null;
    }
  },
};
</script>

<template>
  <div class="audio-player">
    <button class="play-audio" @click="togglePlay">
      <IconsPause v-if="isPlaying" />
      <IconsPlay v-else />
    </button>
    <div ref="waveform">
      <!-- the waveform will be rendered here -->
    </div>
  </div>
</template>